"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var JobRequisitionApplyStatusGetter = (function () {
    function JobRequisitionApplyStatusGetter() {
    }
    JobRequisitionApplyStatusGetter.prototype.getApplyStatus = function (applyStatus) {
        switch (applyStatus) {
            case 0:
                return {
                    applyText: csod.locales.get("This job is not currently available", "This job is not currently available"),
                    canUserApply: false
                };
            case 1:
                return {
                    applyText: csod.locales.get("Application Submitted", "Application Submitted"),
                    canUserApply: false
                };
            case 2:
                return {
                    applyText: csod.locales.get("Apply Now", "Apply Now"),
                    canUserApply: true
                };
            case 3:
                return {
                    applyText: csod.locales.get("Reapply", "Reapply"),
                    canUserApply: true
                };
            case 4:
                return {
                    applyText: csod.locales.get("Continue", "Continue"),
                    canUserApply: true
                };
            case 5:
                return {
                    applyText: csod.locales.get("ATS.JobApplicant.ApplyStatus.DoNotAllowApply", "Unavailable for Application"),
                    canUserApply: false
                };
            default:
                return {
                    applyText: "",
                    canUserApply: false
                };
        }
    };
    return JobRequisitionApplyStatusGetter;
}());
exports.JobRequisitionApplyStatusGetter = JobRequisitionApplyStatusGetter;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/JobRequisitionApplyStatusGetter.ts
// module id = 339
// module chunks = 0